import { z } from "zod/mini"

export const BooleanContentType = "BooleanContent" as const

export const BooleanContentSchema = z.object({
	__TYPE__: z.literal(BooleanContentType),
	value: z.boolean(),
})

export type BooleanContent = z.infer<typeof BooleanContentSchema>
